import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const InfoCardGrid = ({ cards }) => {

    return (
        <Row
            className={'g-3'}>
            {cards.map((card) => (
                <Col
                    md={4}
                    key={card.title}>
                    <Card
                        className={'h-100'}>
                        <Link
                            style={{
                                color: 'inherit',
                                textDecoration: 'none',
                            }}
                            to={card.url}>
                            <Card.Img
                                className={'p-2'}
                                variant={'top'}
                                src={card.image} />
                        </Link>
                        <Card.Body>
                            <h4>
                                <Link
                                    style={{
                                        color: 'inherit',
                                        textDecoration: 'none',
                                    }}
                                    to={card.url}>
                                    {card.title}
                                </Link>
                            </h4>
                            <Card.Text
                                style={{
                                    fontSize: '14px',
                                }}>{card.description}</Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

InfoCardGrid.propTypes = {
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.string,
            title: PropTypes.string,
            description: PropTypes.string,
        })
    ),
};

export default InfoCardGrid;
